import React, { Component } from 'react';
import Radium from 'radium';


class SettingsIcon extends Component {
	render() {
		return (
			<div onClick={this.props.onClick} style={this.localStyles().container}>
				<svg width="26px" height="20px" viewBox="0 0 26 20" version="1.1">
					<title>settings_icon</title>
					<g id="Landing" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<g id="Landing-Light" transform="translate(-1230.000000, -947.000000)">
							<g id="settings_icon" transform="translate(1230.000000, 947.000000)">
								<g id="Group-6">
									<circle id="Oval" stroke={this.props.style.colors.black} strokeWidth="2" cx="22" cy="4" r="3"></circle>
									<rect id="Rectangle" fill={this.props.style.colors.black} x="0" y="3" width="16" height="3" rx="1.5"></rect>
								</g>
								<g id="Group-5" transform="translate(0.000000, 12.000000)">
									<circle id="Oval" stroke={this.props.style.colors.black} strokeWidth="2" transform="translate(4.000000, 4.000000) rotate(-180.000000) translate(-4.000000, -4.000000) " cx="4" cy="4" r="3"></circle>
									<rect id="Rectangle" fill={this.props.style.colors.black} transform="translate(18.000000, 3.500000) rotate(-180.000000) translate(-18.000000, -3.500000) " x="10" y="2" width="16" height="3" rx="1.5"></rect>
								</g>
							</g>
						</g>
					</g>
				</svg>
			</div>
			
		)
	}

	localStyles() {
		return {
			container: {
				cursor: "pointer"
			}
		}
	}
}

export default Radium(SettingsIcon);


// WEBPACK FOOTER //
// ./src/components/SettingsIcon.js